import { useMemo, useState } from 'react';
import type { Company, Contact, Opportunity } from '@client-outreach/shared';
import { Icon } from './Visuals';

export function GlobalSearch({contacts,companies,opportunities,onContact,onCompany,onOpportunity}:{
  contacts:Contact[];companies:Company[];opportunities:Opportunity[];
  onContact:(contact:Contact)=>void;onCompany:(company:Company)=>void;onOpportunity:(opportunity:Opportunity)=>void;
}){
  const [query,setQuery]=useState('');
  const [focused,setFocused]=useState(false);
  const q=query.trim().toLowerCase();
  const results=useMemo(()=>{
    if(q.length<2)return {contacts:[],companies:[],opportunities:[]};
    const includes=(value:string)=>value.toLowerCase().includes(q);
    return {
      contacts:contacts.filter(x=>!x.archived&&includes(`${x.fullName} ${x.title} ${x.companyName} ${x.email||''}`)).slice(0,5),
      companies:companies.filter(x=>!x.archived&&includes(`${x.name} ${x.industry||''} ${x.website||''}`)).slice(0,5),
      opportunities:opportunities.filter(x=>includes(`${x.name} ${x.companyName||''} ${x.location||''} ${x.sport||''}`)).slice(0,5)
    };
  },[q,contacts,companies,opportunities]);
  const total=results.contacts.length+results.companies.length+results.opportunities.length;
  const choose=(fn:()=>void)=>{fn();setQuery('');setFocused(false);};
  return <div className={`globalSearch ${focused?'open':''}`}>
    <Icon name="search"/>
    <input value={query} onFocus={()=>setFocused(true)} onChange={e=>setQuery(e.target.value)} onKeyDown={e=>{if(e.key==='Escape'){setQuery('');setFocused(false);}}} placeholder="Search people, companies, opportunities" aria-label="Global search"/>
    {focused&&q.length>=2&&<div className="globalSearchMenu" onMouseDown={e=>e.preventDefault()}>
      {results.contacts.length>0&&<section><span>PEOPLE</span>{results.contacts.map(contact=><button key={contact.id} onClick={()=>choose(()=>onContact(contact))}><strong>{contact.fullName}</strong><small>{contact.title} · {contact.companyName}</small></button>)}</section>}
      {results.companies.length>0&&<section><span>COMPANIES</span>{results.companies.map(company=><button key={company.id} onClick={()=>choose(()=>onCompany(company))}><strong>{company.name}</strong><small>{company.industry||company.website||'Company'}</small></button>)}</section>}
      {results.opportunities.length>0&&<section><span>OPPORTUNITIES</span>{results.opportunities.map(opportunity=><button key={opportunity.id} onClick={()=>choose(()=>onOpportunity(opportunity))}><strong>{opportunity.name}</strong><small>{opportunity.companyName||opportunity.location||opportunity.sport||'Opportunity'}</small></button>)}</section>}
      {!total&&<div className="globalSearchEmpty">No matches.</div>}
    </div>}
  </div>;
}
